// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextIfr } from '../../Project.context';
import { ContextIfrForecast } from '../Ifr.context';

// mui
import { Container, Grid } from '@mui/material';

// ui
import { TableSheet } from '../../../../ui/TableSheet/TableSheet';

// pages
import { GridColDefIfr } from '../Ifr';

export const Forecast = () => {
	// hooks
	const { t } = useTranslation();

	// context
	const { ifr, ifrTables, setIfrPayload } = useContext(ContextIfr);
	const { setValues } = useContext(ContextIfrForecast);

	// vars
	const forecast = ifrTables?.forecast;
	const columns = forecast?.columns || [];
	const rows = forecast?.rows || [];
	const palette = forecast?.palette || 'blue';

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TableSheet
								columns={columns}
								isExpandable={false}
								label={t('forecast')}
								onDataChange={(row, field, value) => {
									// update values state
									setValues((valuesOld) => {
										const valuesNew = { ...valuesOld };
										if (value !== undefined) {
											valuesNew[row.id as string] = {
												...valuesNew[row.id as string],
												[field]: Number(value) || 0,
											};
										}
										return valuesNew;
									});

									// update payload
									setIfrPayload((ifrPayloadOld) => {
										const ifrPayloadNew = { ...ifrPayloadOld };
										const column = columns.find((c) => c.field === field);
										const loanId = (column as GridColDefIfr)?.loan?.id;

										if (value !== undefined && loanId) {
											const amount = Number(value) || 0;

											// Handle different row types
											if (row.id === 'total-forecasted-payments') {
												if (!('forecasts' in ifrPayloadNew)) {
													ifrPayloadNew.forecasts = [];
												}
												const existingForecast = ifrPayloadNew?.forecasts?.find(
													(f) => f.loan === loanId
												);
												if (existingForecast) {
													existingForecast.amount = amount;
												} else if (ifr?.currency) {
													ifrPayloadNew?.forecasts?.push({
														amount,
														currency: ifr.currency,
														loan: loanId,
													});
												}

												// Remove forecasts with zero amount
												ifrPayloadNew.forecasts = ifrPayloadNew.forecasts?.filter(
													(f) => f.amount !== 0
												);
											} else if (
												['direct-payment', 'sc-payments', 'reimbursements'].includes(row.id)
											) {
												if (!('forecastDeductions' in ifrPayloadNew)) {
													ifrPayloadNew.forecastDeductions = [];
												}
												const transactionTypeMap = {
													'direct-payment': 'DIRECT',
													'sc-payments': 'SPECIAL',
													reimbursements: 'REIMBURSEMENT',
												};
												const transactionType =
													transactionTypeMap[row.id as keyof typeof transactionTypeMap];
												const existingDeduction = ifrPayloadNew?.forecastDeductions?.find(
													(fd) => fd.loan === loanId && fd.transactionType === transactionType
												);
												if (existingDeduction) {
													existingDeduction.amount = amount;
												} else if (ifr?.currency) {
													ifrPayloadNew?.forecastDeductions?.push({
														amount,
														currency: ifr.currency,
														loan: loanId,
														transactionType,
													});
												}

												// Remove forecast deductions with zero amount
												ifrPayloadNew.forecastDeductions = ifrPayloadNew.forecastDeductions?.filter(
													(f) => f.amount !== 0
												);
											}
										}
										return ifrPayloadNew;
									});
								}}
								palette={palette}
								rows={rows}
							/>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</Grid>
	);
};
